<template>
    <div class="container">
        <b-row>
            <b-container>
                <h2 class="text-center">{{labels.title}}</h2>
            </b-container>
        </b-row>
        <b-row>
            <div class="col-md-12 d-flex justify-content-end">
                <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="crearSubMenu()">
                    <md-icon>add</md-icon>
                </md-button>
            </div>
            <div class="row col-md-12 justify-content-center mt-2">
                <b-table
                    :items="listaSubMenu"
                    :fields="fields"
                    hover
                    bordered
                    responsive
                    sticky-header="500px"
                    small
                    class="tblEstandar"
                    head-variant="custom-blue"
                    :per-page="perPage"
                    :current-page="currentPage"
                >
                    <template #cell(id_menu)="data">
                        <div class="text-left">{{ nameMenu(data.item.id_menu) }}</div>
                    </template>
                    <template #cell(accionEdit)="data">
                        <md-button
                            style="background-color: #e5ac00; width: 30px; height: 30px;"
                            class="md-fab md-primary"
                            @click="editSubMenu(data.item.id)"
                        >
                            <md-icon>edit</md-icon>
                        </md-button>
                    </template>
                    <template #cell(accionInac)="data">
                        <md-button
                            style="background-color: #cd2838; width: 30px; height: 30px;"
                            class="md-fab md-primary"
                            @click="inactivar(data.item.id)"
                        >
                            <md-icon>delete</md-icon>
                        </md-button>
                    </template>
                </b-table>
                <div class="row col-12 mt-1">
                    <div class="col-10 d-flex justify-content-center">
                        <b-pagination
                            v-model="currentPage"
                            :per-page="perPage"
                            :total-rows="listaSubMenu.length"
                            align="center"
                            size="md"
                            class="custom-pagination"
                        ></b-pagination>
                    </div>
                    <div class="col-2 d-flex justify-content-end">
                        <label class="mr-2 mb-0">Filas por página:</label>
                        <b-form-select
                        v-model="perPage"
                        :options="[5, 10, 50, 100]"
                        size="sm"
                        style="width: 80px;"
                        ></b-form-select>
                    </div>
                </div>
            </div>
        </b-row>
        <CrearSubmenu :modCrearSubmenu="modCrearSubMenu" @cierraModal="cierraModal" />
        <EditarSubmenu :modEditarSubmenu="modEditarSubMenu" :item="infoSubmenu" @cierraModal="cierraModal" />
        <InacticaItem :InactivaItem="modInactivaSubMenu" @cierraModal="cierraModal" @confirmDelete="inactivaSubMenu"></InacticaItem>
    </div>    
</template>

<script>
import Menu from '../../../services/Menu';
import SubMenu from '../../../services/SubMenu';
import CrearSubmenu from './CrearSubmenu.vue';
import EditarSubmenu from './EditarSubmenu.vue';
import InacticaItem from '../../utils/InacticaItem.vue';

export default {
    name:'submenus',
    data: () => ({
        listaMenu: [],
        listaSubMenu: [],
        modCrearSubMenu: false,
        modEditarSubMenu: false,
        modInactivaSubMenu: false,
        infoSubmenu: [],
        idMenuInac: "",
        perPage: 50,
        currentPage: 1,
        fields: [
            { key: 'nombre', label: 'Nombre'},
            { key: 'descripcion', label: 'Descripción'},
            { key: 'id_menu', label: 'Menú'},
            { key: 'orden', label: 'Orden'},
            { key: 'accionEdit', label: 'Editar', thClass: 'text-center', tdClass: 'text-center'},
            { key: 'accionInac', label: 'Inactivar', thClass: 'text-center', tdClass: 'text-center'},
        ],
    }),
    components:{
        CrearSubmenu,
        EditarSubmenu,
        InacticaItem
    },
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title : 'Submenus',
                    nombre  : "Nombre",
                    descripcion : "Descripción",
                    menu : "Menú",
                    editar : "Editar",
                    inactivar : "Inactivar",
                    orden : "Orden",
                }
            }else{
                return {
                    title : 'Submenus',
                    nombre  : "Name",
                    descripcion : "Description",
                    menu : "Menu",
                    editar : "Edit",
                    inactivar : "Inactivate",
                    orden : "Order",
                }
            }
        }
    },
    methods:{
        cierraModal(val){
            this.modCrearSubMenu = val
            this.modEditarSubMenu = val
            this.modInactivaSubMenu = val
        },
        nameMenu(idMenu){
            // console.log(idMenu)
            // console.log(this.listaMenu)
            let nombreMenu = this.listaMenu.find((menu) => menu.id == idMenu )
            // console.log(nombreMenu.nombre)
            return nombreMenu.nombre
        },
        crearSubMenu(){
            this.modCrearSubMenu = true
        },
        editSubMenu(id){
            // console.log(id)
            SubMenu.subMenuById(id)
            .then((res) => {
                // console.log(res.data.dataSubMenu)
                this.infoSubmenu = res.data.dataSubMenu
                this.modEditarSubMenu = true
            })
            .catch((err) => console.log(err))
        },
        inactivar(id){
            // console.log(id)
            this.idMenuInac = id
            this.modInactivaSubMenu = true
        },
        inactivaSubMenu(){
            // console.log(this.idMenuInac)
            let info = {'id' : this.idMenuInac}
            SubMenu.inactivaSubmenu(info)
            .then((res) => {
                if(res.status == 200){
                    this.$toast.success(res.data.message)
                    this.modInactivaSubMenu = false
                    location.reload();
                }
            })
            .catch((err) => console.log(err))
        }

    },
    mounted(){
        Menu.getAllMenu()
        .then((res) => {
            this.listaMenu = res.data.listMenu
        })
        .catch((err) => console.log(err))

        SubMenu.getAllSubMenu()
        .then((res) => {
            this.listaSubMenu = res.data.listSubMenu
        })
        .catch((err) => console.log(err))
    }
}
</script>

<style>

</style>
